import React, { useState } from "react";
import "../../Styles/MahaShakthiForm.css";

const AdminMahaShakthiForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    relation: "",
    age: "",
    aadhaar: "",
    voterId:"",
    mobile: "",
    busPassNumber: "",
    route: "",
    depot: "",
    village: "",
    mandal: "",
    date: "",
    status: "",
    remarks: "",
    photo: null,
    document: null,
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData({
      ...formData,
      [name]: files ? files[0] : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData);
  };

  return (
    <div className="mahashakthi-form-container">
      <div className="mahashakthi-form-card">
        <div className="mahashakthi-form-header">
          <h2>Add New Maha Shakthi Beneficiary</h2>
          <p>Free travel for women across all APSRTC buses</p>
          <button
            className="mahashakthi-back-btn"
            onClick={() => window.history.back()}
          >
            Back
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mahashakthi-form-grid">

            <div className="mahashakthi-form-group">
              <label>Beneficiary Name *</label>
              <input
                type="text"
                name="name"
                placeholder="Enter Beneficiary Name"
                onChange={handleChange}
              />
            </div>

            <div className="mahashakthi-form-group">
              <label>Relation *</label>
              <input
                type="text"
                name="relation"
                placeholder="Ex: D/O, W/O"
                onChange={handleChange}
              />
            </div>

            <div className="mahashakthi-form-group">
              <label>Age *</label>
              <input
                type="number"
                name="age"
                placeholder="Enter Age"
                onChange={handleChange}
              />
            </div>

            <div className="mahashakthi-form-group">
              <label>Aadhaar Number *</label>
              <input
                type="text"
                name="aadhaar"
                placeholder="Enter 12-digit Aadhaar Number"
                maxLength="12"
                onChange={handleChange}
              />
            </div>
             <div className="mahashakthi-form-group">
              <label>Voter Id *</label>
              <input
                type="text"
                name="voterId"
                placeholder="Enter Voter Id"
                maxLength="10"
                onChange={handleChange}
              />
            </div>

            <div className="mahashakthi-form-group">
              <label>Mobile Number *</label>
              <input
                type="tel"
                name="mobile"
                placeholder="Enter Mobile Number"
                maxLength="10"
                onChange={handleChange}
              />
            </div>

            <div className="mahashakthi-form-group">
              <label>Bus Pass Number *</label>
              <input
                type="text"
                name="busPassNumber"
                placeholder="Enter Bus Pass Number"
                onChange={handleChange}
              />
            </div>

            <div className="mahashakthi-form-group">
              <label>Preferred Route *</label>
              <input
                type="text"
                name="route"
                placeholder="Ex: Kandukur to Ongole"
                onChange={handleChange}
              />
            </div>

            <div className="mahashakthi-form-group">
              <label>Depot *</label>
              <input
                type="text"
                name="depot"
                placeholder="Enter APSRTC Depot Name"
                onChange={handleChange}
              />
            </div>

            <div className="mahashakthi-form-group">
              <label>Village *</label>
              <input
                type="text"
                name="village"
                placeholder="Enter Village"
                onChange={handleChange}
              />
            </div>

            <div className="mahashakthi-form-group">
              <label>Mandal *</label>
              <select name="mandal" onChange={handleChange}>
                <option>Select Mandal</option>
                <option>Kandukur</option>
                <option>Gudluru</option>
                <option>Ulavapadu</option>
              </select>
            </div>

            <div className="mahashakthi-form-group">
              <label>Date *</label>
              <input
                type="date"
                name="date"
                onChange={handleChange}
              />
            </div>

            <div className="mahashakthi-form-group">
              <label>Status *</label>
              <select name="status" onChange={handleChange}>
                <option>Select Status</option>
                <option>Approved</option>
                <option>Pending</option>
              </select>
            </div>

            <div className="mahashakthi-form-group">
              <label>Upload Photo *</label>
              <input
                type="file"
                name="photo"
                accept="image/*"
                onChange={handleChange}
              />
            </div>

            <div className="mahashakthi-form-group">
              <label>Upload Supporting Document</label>
              <input
                type="file"
                name="document"
                accept=".pdf,image/*"
                onChange={handleChange}
              />
            </div>

          </div>

          <div className="mahashakthi-form-group mahashakthi-full-width">
            <label>Remarks</label>
            <textarea
              rows="4"
              name="remarks"
              placeholder="Enter Remarks"
              onChange={handleChange}
            ></textarea>
          </div>

          <div className="mahashakthi-btn-group">
            <button type="submit" className="mahashakthi-submit-btn">
              Submit
            </button>
            <button type="reset" className="mahashakthi-reset-btn">
              Reset
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminMahaShakthiForm;